<template>
  <v-dialog
    width="550"
    v-model="opened"
    @keydown.esc="$emit('update:opened', false)"
  >
    <input
      type="file"
      style="display: none"
      multiple
      :accept="supportedFileType"
      ref="selectedDocuments"
      @change="onDocumentsPicked"
    />

    <v-card flat @drop.prevent="addFile" @dragover.prevent>
      <v-card-title class="title text-xs-left pb-0">
        Upload PDF or image for {{ company.name }}
      </v-card-title>
      <v-card-text>
        <v-flex class="text-xs-left">
          <v-alert
            :value="true"
            type="info"
            outline
            v-if="importMethod === 'tax_return'"
          >
            Please note that this process may take several business days.
          </v-alert>

          <v-layout align-center>
            <div class="py-3 font-weight-bold">
              {{ $t('documents.selectedDocuments') }}:
            </div>
            <v-spacer />
            <v-btn
              outline
              class="default-input text-capitalize primary--text"
              :disabled="documentsImporting"
              @click="pickDocuments"
            >
              <v-layout align-center>
                <v-icon class="mr-2" size="20">add</v-icon>
                <div v-if="!documentData">Select File</div>
                <div v-else>Select Other File</div>
              </v-layout>
            </v-btn>
          </v-layout>
        </v-flex>

        <v-layout align-center class="text-xs-left">
          <v-flex class="text-xs-left mb-4" v-if="isEmpty(documentsToImport)">
            No document selected.
          </v-flex>
          <v-flex class="mb-4" v-else>
            <v-layout
              align-center
              :key="i"
              v-for="(doc, i) in documentsToImport"
            >
              <v-icon color="primary"> insert_drive_file </v-icon>
              <span class="ml-1 my-1">{{ doc.name }}</span>
              <v-spacer />
              <v-icon
                @click="documentsToImport.splice(i, 1)"
                style="cursor: pointer"
                color="error"
                >cancel</v-icon
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="text-capitalize primary"
          @click="upload"
          :loading="documentsImporting"
          :disabled="isEmpty(documentsToImport)"
        >
          Upload
        </v-btn>
        <v-btn
          class="text-capitalize error--text"
          outline
          @click="
            $emit('update:opened', false);
            documentsToImport = [];
          "
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import API from '@/api';
import get from 'lodash/get';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    company: {
      type: Object,
      required: true,
    },

    year: {
      type: Number,
    },

    importMethod: {
      type: String,
    },
  },

  data() {
    return {
      documentData: '',
      documentsToImport: [],
      documentsImporting: false,
    };
  },

  computed: {
    supportedFileType() {
      return this.importMethod === 'taxprep_return'
        ? '.csv'
        : 'application/pdf, image/*';
    },
  },

  methods: {
    isEmpty,
    get,

    pickDocuments() {
      const input = this.$refs.selectedDocuments;
      input.type = 'text';
      input.type = 'file';
      this.$refs.selectedDocuments.click();
    },

    async onDocumentsPicked(e) {
      this.documentsImporting = true;
      const documents = e.target.files;

      if (documents) {
        this.documentsToImport.push(...documents);
        this.documentsImporting = false;
      }
    },

    async addFile(e) {
      const documents = e.dataTransfer.files;
      if (documents) {
        this.documentsToImport.push(...documents);
      }
    },

    async upload() {
      this.documentsImporting = true;

      try {
        let fail = 0;
        for (const documentToImport of this.documentsToImport) {
          const {
            data: { id, upload_link },
          } = await API.integration.getTemporaryUploadLink({
            companyId: this.company.id,
          });

          await API.integration.uploadToDropbox(upload_link, documentToImport);

          const response = await API.integration.processDocument({
            id,
            documentName: documentToImport.name,
            companyId: this.company.id,
            path: `/${this.year}/Tax Returns and Tax Organizers (STAFF ONLY)`,
            documentType: this.importMethod,
            taxYear: this.year,
          });

          if (response.data.error) {
            fail += 1;
            console.log(response.data.error);
          }
        }

        if (fail === 0) {
          if (this.importMethod === 'tax_return') {
            this.$store.dispatch('application/setSuccessNotification', {
              message:
                'Successfully uploaded. Rollover items will be imported in 1-2 business days, and we will send you a notification once it is done!',
            });
          } else {
            this.$store.dispatch('application/setSuccessNotification', {
              message:
                'Successfully uploaded. Rollover items will be imported automatically within few minutes. You will get a notification for review once it is done.',
            });
          }

          this.$emit('update:opened', false);
          this.$emit('uploaded');
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message: `There was a problem uploading ${fail} files.`,
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem uploading the file',
        });
      } finally {
        this.userImportDialogOpened = false;
        this.documentsImporting = false;
        this.documentsToImport = [];
      }
    },
  },
};
</script>
